import React from 'react';
import { connect } from 'react-redux';
import {
  requestFetchPlans,
  initViewPlanDetails,
  beginInitFeaturesTree,
  push
} from 'actions';
import {
  Panel,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Button
} from 'react-bootstrap';
import {
  Container,
  LoadingSpinner,
  PlanDetailsModal
} from 'components';

class PlansList extends React.Component {
  constructor(props) {
    super(props);

    this.renderPlansCategory = this.renderPlansCategory.bind(this);
    this.renderPlans = this.renderPlans.bind(this);
  }

  renderPlansCategory(name, plans) {
    return (
      <Col md={6} xs={12}>
        <Panel>
          <Row>
            <Col md={12} xs={12}>
              <h4><span><i className='fa fa-map' /></span>{`  ${name}`}</h4>
            </Col>
          </Row>
          <ListGroup>
            {plans.map(plan => {
              return (
                <ListGroupItem onClick={() => this.props.initViewPlanDetails(plan)} key={plan._id}>
                  {`${plan.name} - ${plan.interval[0].toUpperCase()}${plan.interval.substr(1)}`}
                </ListGroupItem>
              )
            })}
          </ListGroup>
        </Panel>
      </Col>
    );
  }
  renderPlans() {
    const plans_list = this.props.plans.plans_list || [];
    const map_plans = plans_list.filter(p => [ 'map_national', 'map_state', 'map_city' ].includes(p.type));
    const crm_plans = plans_list.filter(p => p.type == 'crm');
    const data_plans = plans_list.filter(p => p.type == 'data');
    const canvassing_plans = plans_list.filter(p => p.type == 'canvassing');

    return (
      <div>
        <Row>
          {this.renderPlansCategory('Map Plans', map_plans)}
          {this.renderPlansCategory('CRM Plans', crm_plans)}
        </Row>
        <Row>
          {this.renderPlansCategory('Data Plans', data_plans)}
          {this.renderPlansCategory('Canvassing Plans', canvassing_plans)}
        </Row>
      </div>
    )
  }
  componentWillMount() {
    if(!this.props.plans.initialized) {
      this.props.requestFetchPlans();
    }
    this.props.beginInitFeaturesTree();
  }

  render() {
    return (
      <Container title='Plans List'>
        <div className='plans-list-container'>
          <Panel header='Plans'>
            {this.props.plans.fetching_plans ? (
              <LoadingSpinner />
            ) : (
              this.renderPlans()
            )}
            <Row>
              <Col md={6} xs={12} mdOffset={6}>
                <Button
                  block
                  bsStyle='success'
                  onClick={() => this.props.push('/sales-site/plans/create')}
                  >
                  <i className='fa fa-plus' />{'  '}Create Plan
                </Button>
              </Col>
            </Row>
          </Panel>
        </div>
        <PlanDetailsModal />
      </Container>
    )
  }
}

const mapStateToProps = ({ plans }) => ({ plans });
const actions = {
  requestFetchPlans,
  initViewPlanDetails,
  beginInitFeaturesTree,
  push
}

export default connect(mapStateToProps, actions)(PlansList);



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/plans/plans-list.js